import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { UserPartnerOrCustomerInfo } from 'src/app/core/services/AdminService/admin-service-generate';

export class SelectedCustomerObject {
  customerId: string;
  customerTitle: string;
  leaveTime: string;
}
interface LeaveTime {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-operator-permission-dialog',
  templateUrl: './operator-permission-dialog.component.html',
  styleUrls: ['./operator-permission-dialog.component.css'],
})
export class OperatorPermissionDialogComponent implements OnInit {
  selectedCustomer: string = null;
  selectedLeaveTime: string = null;
  customerList: UserPartnerOrCustomerInfo[];
  selectedCustomerObject: SelectedCustomerObject;
  leaveTime: LeaveTime[] = [
    { value: '360', viewValue: '6 Saat' },
    { value: '720', viewValue: '12 Saat' },
    { value: '1440', viewValue: '24 Saat' },
  ];

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    console.log(this.customerList);
  }

  changeClick() {
    this.selectedCustomerObject = new SelectedCustomerObject();
    this.selectedCustomerObject.customerId = this.selectedCustomer;
    this.selectedCustomerObject.leaveTime = this.selectedLeaveTime;
    this.selectedCustomerObject.customerTitle = this.customerList.filter(
      (x) => x.identityId == this.selectedCustomer
    )[0]?.title;
    this.dialogRef.close(this.selectedCustomerObject);
  }
}
